import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, TrendingUp, Receipt, Truck, Users, PiggyBank, FileBarChart, Settings } from "lucide-react";
import { cn } from "@/lib/utils";

const MENU = [
  { to: "/accounts", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/accounts/sales", label: "Daily Sales", icon: TrendingUp },
  { to: "/accounts/expenses", label: "Daily Expenses", icon: Receipt },
  { to: "/accounts/suppliers", label: "Supplier Payments", icon: Truck },
  { to: "/accounts/salaries", label: "Salary Management", icon: Users },
  { to: "/accounts/income", label: "Other Income", icon: PiggyBank },
  { to: "/accounts/reports", label: "Reports", icon: FileBarChart },
  { to: "/accounts/settings", label: "Settings", icon: Settings },
];

export default function BALayout() {
  return (
    <div className="space-y-6" data-testid="business-accounts-page">
      <div>
        <h1 className="font-heading text-2xl lg:text-3xl font-semibold tracking-tight">Business Accounts</h1>
        <p className="text-sm text-muted-foreground mt-1">Standalone accounts book — independent from ERP data</p>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {MENU.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={`ba-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) =>
              cn("flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap border transition-colors",
                isActive ? "bg-primary text-primary-foreground border-primary" : "bg-card text-muted-foreground hover:text-foreground")}
          >
            <Icon className="h-3.5 w-3.5" /> {label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
